<cb-dialog [dialogHeading]="dialogHeading()" *cbWaitFor="categoriesLoaded && currentLotSpecItemSet">
    <form class="flex-col flex" #itemForm="ngForm" id="itemForm">
        <cb-select
            label="House Area"
            name="name"
            [(ngModel)]="mappedItem.specGroupId"
            [options]="houseAreas"
            [readonly]="isHouseAreaDisabled()"
            [required]="true"
            (change)="specGroupSelected($event)"
        ></cb-select>
        <cb-slot-autocomplete-scroller
            class="cb-margin-top flex flex-row"
            #scrollerComponent
            label="Schedule Item Name"
            name="selectedScheduleItem"
            style="min-width: 300px"
            [(ngModel)]="selectedSlot"
            [requireMatch]="true"
            [matchProps]="['id']"
            [specGroupId]="isAddItem() ? mappedItem.specGroupId : null"
            [lotId]="isCreditItem() ? mappedItem.lotId : null"
            [excludeIds]="data.excludedSlotIds"
            (optionSelected)="scheduleItemSelected($event)"
            [required]="true"
            [shouldShowHouseAreaInLabel]="true"
            [readonly]="(isEdit$ | async) || (!(mappedItem?.specGroupId > 0) && isAddItem())"
        >
        </cb-slot-autocomplete-scroller>
        @if (isAddItem()) {
            <cb-display-value-new
                [value]="mappedItem?.currentLotSpecItem"
                label="Current Lot Spec Item"
            >
            </cb-display-value-new>
        }
        <div class="cb-margin-top-2x flex-col flex">
            <h4 class="mat-h4 cb-margin-bottom-2x">
                <b>Item Details</b>
            </h4>
            @if (!updatingScheduleItem) {
                <cb-select
                    name="costType"
                    label="Cost Type"
                    [options]="changeOptionLineCostTypes"
                    [required]="true"
                    [(ngModel)]="mappedItem.costType"
                    (change)="clearProductForCostType()"
                    [readonly]="isCreditItem()"
                >
                </cb-select>
            }
            @if (isNotDescriptive()) {
                <cb-display-value-new [value]="mappedItem?.category?.name" label="Product Category">
                </cb-display-value-new>
            }
            @if (isNotDescriptive()) {
                <div class="start-center flex-row">
                    <cb-product-centre-autocomplete-scroller
                        #productAutocomplete
                        class="cb-margin-right flex"
                        label="New Product / Description"
                        name="product"
                        [maxlength]="1499"
                        [(ngModel)]="mappedItem.selectedProduct"
                        [required]="true"
                        [businessEntityIds]="businessEntityIdAndNationalId"
                        [requireMatch]="isActual() && isAddItem()"
                        [matchProps]="['id']"
                        [hideCompositeItems]="false"
                        [orderByStandardProduct]="true"
                        [categoryId]="
                            mappedItem?.category?.id > 0 ? mappedItem?.category?.id : null
                        "
                        (searchTextChanged)="productSearchTextChanged($event)"
                        [readonly]="isCreditItem()"
                        (optionSelected)="productUpdate($event)"
                    >
                    </cb-product-centre-autocomplete-scroller>
                    @if (!productAutocomplete.readonly) {
                        <cb-product-centre-find
                            name="selectedProduct"
                            [required]="true"
                            [buttonOnly]="true"
                            [activeOnly]="true"
                            [categoryIdFilter]="
                                mappedItem?.slotCategory?.id > 0
                                    ? mappedItem.slotCategory.id
                                    : undefined
                            "
                            label="Product"
                            class="product-centre-find"
                            [initializeSearchOnLoad]="true"
                            [businessEntityIdsToSortBy]="businessEntityIdAndNationalId"
                            [restrictedBusinessEntityIds]="businessEntityIdAndNationalId"
                            [existingSlotItem]="existingSlotItem"
                            [showCurrentProduct]="true"
                            [currentProductTitle]="'Current Lot Spec Item'"
                            [hideNationalRate]="true"
                            (productSelected)="productSelected($event, true)"
                        >
                        </cb-product-centre-find>
                    }
                </div>
            }
            @if (isDescriptiveOnly()) {
                <cb-text-area
                    type="text"
                    name="description"
                    label="Description"
                    [required]="true"
                    [maxlength]="1500"
                    [(ngModel)]="mappedItem.itemDetails"
                    (change)="descriptionTextChanged()"
                    [readonly]="isCreditItem()"
                >
                </cb-text-area>
            }
            <cb-input
                type="number"
                label="Quantity"
                [required]="true"
                [(ngModel)]="mappedItem.quantity"
                name="quantity"
                (change)="updateQuantity()"
            ></cb-input>
            @if (itemForm.controls?.quantity?.errors?.invalid) {
                <span class="error-msg mat-caption cb-error">
                    Quantity is not allowed to exceed {{ maximumQuantity }}
                </span>
            }
            <cb-currency
                label="Rate"
                name="rate"
                [(ngModel)]="mappedItem.rate"
                [required]="true"
                [inclGst]="isProvisional()"
                (change)="getCostAmount()"
            ></cb-currency>
            <cb-currency
                class="space-below"
                label="Amount"
                name="costAmount"
                [required]="true"
                [(ngModel)]="mappedItem.costAmount"
                [readonly]="true"
            >
            </cb-currency>
            @if (isAddItem()) {
                <cb-checkbox
                    name="includeInCreateSchedule"
                    label="Include in Flyer / Create Schedule"
                    [(ngModel)]="mappedItem.showInClientSpecification"
                    [readonly]="isView$ | async"
                >
                </cb-checkbox>
            }
            @if (isAddItem()) {
                <cb-checkbox
                    name="includeInColourSchedule"
                    label="Include in Colour Schedule"
                    [(ngModel)]="mappedItem.showInColourYourDreams"
                    [readonly]="isView$ | async"
                >
                </cb-checkbox>
            }
            @if (isAddItem()) {
                <cb-checkbox
                    name="manualColourEntryRequired"
                    label="Manual Colour Entry Required"
                    [(ngModel)]="mappedItem.manualColourEntryRequired"
                    [readonly]="isView$ | async"
                >
                </cb-checkbox>
            }
            <cb-text-area
                label="QS Comments"
                name="comments"
                [(ngModel)]="mappedItem.comments"
                [maxlength]="1024"
            >
            </cb-text-area>
        </div>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            (cbClick)="addOrUpdateItem()"
            [clickLimit]="1"
            [disabled]="itemForm.pristine || itemForm.invalid"
        >
            {{ (isEdit$ | async) ? 'Update' : 'Add' }}
        </button>
        <button mat-raised-button (cbClick)="cancel()">Cancel</button>
    </div>
</cb-dialog>
